var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3939 6.875L17.8259 16.6211C17.7623 17.7113 16.8677 18.5625 15.7856 18.5625H6.01476C4.93264 18.5625 4.03808 17.7113 3.97453 16.6211L3.40645 6.875M8.85644 10.6562L10.9002 12.7188M10.9002 12.7188L12.9439 14.7812M10.9002 12.7188L12.9439 10.6562M10.9002 12.7188L8.85644 14.7812M3.06582 6.875H18.7346C19.2989 6.875 19.7564 6.41329 19.7564 5.84375V4.46875C19.7564 3.89921 19.2989 3.4375 18.7346 3.4375H3.06582C2.50145 3.4375 2.04395 3.89921 2.04395 4.46875V5.84375C2.04395 6.41329 2.50145 6.875 3.06582 6.875Z",
    stroke: "#120A8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.755e478f5664d7d9997f93a9b6226e98.svg";
export { ForwardRef as ReactComponent };